import axios from "axios";
import Cookies from "universal-cookie";
import { COMPANYNAME, COMPANY_ID, TOKEN_NAME, config, PRODUCT_SLUG } from "../config";
const cookies = new Cookies();

let company_id = cookies.get(COMPANY_ID);
console.log(company_id, "companyid");

export const getMetaData = async () => {
  let token = cookies.get(TOKEN_NAME);
  let company_id = cookies.get(COMPANY_ID);
  var form_data = new FormData();
  form_data.append("company_id", company_id); // <-- Add company id here
  form_data.append("product_slug", PRODUCT_SLUG);

  var res = await axios({
    method: "GET",
    url: `${config.apiurl}leaveapplicationcountadmin?company_id=${company_id}&product_slug=${PRODUCT_SLUG}`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: token ? `Bearer ${token}` : "",
    },
    data:form_data
  });
  return await res;
};
export const getUserName = async (typeOfEmployee) => {
  let token = cookies.get(TOKEN_NAME);
  let company_id = cookies.get(COMPANY_ID);
  var form_data = new FormData();
  form_data.append("type_of_employee", typeOfEmployee);
  form_data.append("company_id", company_id); // <-- Add company id here
  form_data.append("product_slug", PRODUCT_SLUG);
  var res = await axios({
    method: "POST",
    url: `${config.apiurl}fetchusername`,
    data: form_data,
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });
  return await res;
};
export const getUserLeaveData = async (company_employee_id = "") => {
  let token = cookies.get(TOKEN_NAME);
  let company_id = cookies.get(COMPANY_ID);
  var form_data = new FormData();
  form_data.append("company_employee_id", company_employee_id);
  form_data.append("page_no", 0);
  form_data.append("limit", 10);
  form_data.append("company_id", company_id); // <-- Add company id here
  form_data.append("product_slug", PRODUCT_SLUG);
  var res = await axios({
    method: "POST",
    url: `${config.apiurl}leavelisting`,
    data: form_data,
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });
  return await res;
};

export const downloadReport = async (data) => {
  let token = cookies.get(TOKEN_NAME);
  let company_id = cookies.get(COMPANY_ID);
  var form_data = new FormData();
  for (var key in data) {
    form_data.append(key, data[key]);
  }
  form_data.append("company_id", company_id); // <-- Add company id here
  form_data.append("product_slug", PRODUCT_SLUG);
  var res = await axios({
    method: "POST",
    responseType: "blob",
    data: form_data,
    url: `${config.apiurl}salary_report`,
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });
  return res;
};

export const downloadUserReport = async (data = {}) => {
  let token = cookies.get(TOKEN_NAME);
  let company_id = cookies.get(COMPANY_ID);

  // Add company_id and product_slug to data object
  const params = new URLSearchParams({ ...data, company_id, product_slug: PRODUCT_SLUG }).toString();

  var res = await axios({
    method: "GET",
    responseType: "blob",
    url: `${config.apiurl}users_list?${params}`, // Pass parameters in the URL
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });

  return res;
};

export const getAnalyticsStats = async () => {
  let token = cookies.get(TOKEN_NAME);
  let company_id = cookies.get(COMPANY_ID);
  var res = await axios({
    method: "GET",
    url: `${config.apiurl}analytics/dashboard-stats?company_id=${company_id}&product_slug=${PRODUCT_SLUG}`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return res;
};

export const getEmployeeAnalyticsStats = async () => {
  let token = cookies.get(TOKEN_NAME);
  let company_id = cookies.get(COMPANY_ID);
  var res = await axios({
    method: "GET",
    url: `${config.apiurl}analytics/employee-stats?company_id=${company_id}&product_slug=${PRODUCT_SLUG}`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return res;
};
